import type { Loader } from 'pixi.js';

/**
 * Identifiers passed as first argument to loader.add
 * are basically useless. Fonts are identified by font face name (e.g. OpenSans-Regular),
 * these are only global pixi resource names not used to refer the fonts.
 */
export function loadFonts(loader: Loader): void {
  loader.add('FontOpenSans-Bold', '/public/fonts/OpenSans-Bold.fnt');
  loader.add('FontOpenSans-Regular', '/public/fonts/OpenSans-Regular.fnt');
}
